module.exports = __webpack_public_path__ + "img/heizhuxianrou.ac7bbfb9.jpg";